import type { ShareApiError } from '../../lib/shareApi'

/** What a code-free open attempt should fall back to when verify fails. */
export type OpenOutcome = 'gate' | 'error'

/**
 * Decide what a code-free open failure means. Link-only shares open with no code;
 * a link that STILL requires one (legacy coded link) fails codeless verify with
 * `invalid_code` — the only reason that means "prompt for a code" (show the
 * gate). Every other reason (expired, revoked, throttled, session lapse, network)
 * is a genuine error: show the error notice, never a code prompt that can't help.
 */
export function classifyOpenFailure(
  reason: ShareApiError['reason']
): OpenOutcome {
  return reason === 'invalid_code' ? 'gate' : 'error'
}
